import React, { createContext, useContext, useEffect, useState } from 'react';
import { auth } from '../Firebase';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true); // Add loading state

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((currentUser) => {
            setUser(currentUser?.emailVerified ? currentUser : null);
            setLoading(false); // Authentication check completed
        });

        return unsubscribe; // Cleanup listener
    }, []);

    return (
        <AuthContext.Provider value={{ user, loading }}>
            {children}
        </AuthContext.Provider>
    );
};
